import { CFImage, CFVideo } from '../../type/client-index'

export const IndexImage: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/1a69c3d0-7aed-4841-6d1f-61ace7dda000/1500',
  width: 843,
  height: 1500
}

export const IpadIphone: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/cfb34de6-275e-4398-1d49-6d58d1b9b400/1750',
  width: 1750,
  height: 1224
}

export const Reel1: CFVideo = {
  id: 'a37b208bbff319642f98d2064b4c83dc',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/1a69c3d0-7aed-4841-6d1f-61ace7dda000/1500'
}

export const Reel2: CFVideo = {
  id: '651df44cb9055701fbdf30479c254959',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/0ec0008d-1d4e-4ce8-d025-6814db768100/1500'
}

export const Reel3: CFVideo = {
  id: '410530c33d0b4f4d1f6c62b09bd61977',
  cover: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/97d2de21-601d-4f25-d466-c03061606200/1500'
}
